/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_SendInputs */

const en_us2_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send invite`)
};

const pt_br2_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar convite`)
};

const pt_pt2_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar convite`)
};

/** @type {(inputs: Invite_SendInputs) => LocalizedString} */
const es_419_invite_send = en_us2_invite_send;

/** @type {(inputs: Invite_SendInputs) => LocalizedString} */
const fr_fr2_invite_send = en_us2_invite_send;

/** @type {(inputs: Invite_SendInputs) => LocalizedString} */
const de_de2_invite_send = en_us2_invite_send;

/** @type {(inputs: Invite_SendInputs) => LocalizedString} */
const it_it2_invite_send = en_us2_invite_send;

/**
* | output |
* | --- |
* | "Send invite" |
*
* @param {Invite_SendInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_send = /** @type {((inputs?: Invite_SendInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_SendInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_send(inputs)
	if (locale === "es-419") return es_419_invite_send(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_send(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_send(inputs)
	if (locale === "de-DE") return de_de2_invite_send(inputs)
	if (locale === "it-IT") return it_it2_invite_send(inputs)
	return en_us2_invite_send(inputs)
});
export { invite_send as "invite.send" }